import React from 'react';
import { useTranslation } from 'react-i18next';

import { List, ListItem, ListItemText } from '@mui/material';
import { v4 as uuidV4 } from 'uuid';

import { ReactComponent as CheckIcon } from 'assets/icons/CheckIcon.svg';

import styles from '../PlanCard.module.scss';

interface ITranslationKeyWithParams {
  key: string;
  params?: Record<string, any>;
}

interface IFeaturesListProps {
  tariffFeatures: (string | ITranslationKeyWithParams)[];
}

export const FeaturesList: React.FC<IFeaturesListProps> = ({ tariffFeatures }) => {
  const { t } = useTranslation();

  const resolveFeature = (feature: string | ITranslationKeyWithParams) => {
    if (typeof feature === 'string') {
      return t(feature);
    }
    return t(feature.key, feature.params);
  };

  return (
    <List className={styles.listWrapper}>
      {tariffFeatures.map((feature) => (
        <ListItem key={uuidV4()} className={styles.listItem}>
          <CheckIcon style={{minWidth: 20}}/>
          <ListItemText primaryTypographyProps={{ fontSize: '16px' }} className={styles.listItemText}>
            {resolveFeature(feature)}
          </ListItemText>
        </ListItem>
      ))}
    </List>
  );
};
